import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  parsePerfHaloReportSearch,
  serializePerfHaloReportSearch,
} from '@/lib/perf-halo-report-search';
import { requireCapability } from '@/lib/route-guards';

const requireReports = requireCapability('reports_view');

export const Route = createFileRoute('/reports/spillover')({
  validateSearch: parsePerfHaloReportSearch,
  // Route-data exemption: this legacy route always redirects after enforcing report access.
  beforeLoad: async (options) => {
    await requireReports(options);
    throw redirect({
      to: '/reports/perf-halo',
      search: serializePerfHaloReportSearch(options.search),
      replace: true,
    });
  },
});
